export default [
  { id: 1, value: 10, option: '10 min' },
  { id: 2, value: 20, option: '20 min' },
  { id: 3, value: 30, option: '30 min' },
  { id: 4, value: 40, option: '40 min' },
  { id: 5, value: 50, option: '50 min' },
  { id: 6, value: 60, option: '60 min' }
]
